import {useDropzone} from 'react-dropzone';
import { DropzoneContainer } from './styles';

export interface IProps {
  accept: string;
  maxFiles?: number;
  onDrop?: any;
}

export default function FileInputDrop(props: IProps) {

  const {acceptedFiles, getRootProps, getInputProps} = useDropzone({
    maxFiles: props.maxFiles, 
    accept: props.accept,
    onDrop: props.onDrop
  });

  const files = acceptedFiles.map(file => (
    <li key={file.name}>
      {file.name} - {file.size} bytes
    </li>
  ));

  return (
    <DropzoneContainer>
      <div {...getRootProps()}>
        <input {...getInputProps({type: "file"})} />
        <p>Clique ou arraste o(s) arquivo(s) aqui</p>
      </div>
      <aside>
        <ul>{files}</ul>
      </aside>
    </DropzoneContainer>
  );
}